import React, { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { toggleMute, isMuted, resumeAudio, sfx } from "../lib/sound";

export const SoundToggle = () => {
  const [muted, setMuted] = useState(isMuted());
  return (
    <button
      data-testid="sound-toggle"
      aria-label={muted ? "Activer le son" : "Couper le son"}
      onClick={() => {
        resumeAudio();
        const m = toggleMute();
        setMuted(m);
        if (!m) sfx.click();
      }}
      className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/70 backdrop-blur-md transition-transform hover:scale-105 active:scale-95"
    >
      {muted ? <VolumeX size={16} /> : <Volume2 size={16} className="text-[#f093fb]" />}
    </button>
  );
};
